import React from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { Container } from 'semantic-ui-react';
import './titleListingTemplate.scss';

const titleListingTemplate = ({ items }) => {
  return (
    <Container className="view-wrapper">
      <div className="title-listing__buttons">
        {items &&
          items.map((item) => (
            <UniversalLink
              href={item['@id']}
              key={item['@id']}
              className="title-listing__button"
            >
              {item.title ? item.title : item.id}
            </UniversalLink>
          ))}
      </div>
    </Container>
  );
};

export default titleListingTemplate;
